import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';
import { USUARIO_LISTADO } from '../usuario/usuarioActions';

const API = `${consts.API_URL}/coleta`;

export const COLETA_MODO_TELA =
    'COLETA_MODO_TELA';

export const COLETA_SET_AGUARDANDO =
    'COLETA_SET_AGUARDANDO';

export const COLETA_LISTADO =
    'COLETA_LISTADO';

export const COLETA_OPCOES_CARREGADAS =
    'COLETA_OPCOES_CARREGADAS';

export const COLETA_AREAS_CARREGADAS =
    'COLETA_AREAS_CARREGADAS';

export const COLETA_HISTORICO_CARREGADO =
    'COLETA_HISTORICO_CARREGADO';

const normalizarNumero = valor => {
    if (
        valor === null ||
        valor === undefined ||
        valor === ''
    ) {
        return null;
    }

    if (typeof valor === 'number') {
        return valor;
    }

    const texto = valor.toString().trim();
    const numero = Number(
        texto.includes(',')
            ? texto
                .replace(/\./g, '')
                .replace(',', '.')
            : texto
    );

    return Number.isFinite(numero)
        ? numero
        : null;
};

const calcularValorTotal = area => {
    const amostras = normalizarNumero(area.amostras);
    const precoGrid = normalizarNumero(area.preco_grid);

    if (amostras === null || precoGrid === null) {
        return null;
    }

    return Math.round(amostras * precoGrid * 100) / 100;
};

const normalizarDataHora = valor => {
    if (!valor) {
        return valor;
    }

    if (
        /Z$/i.test(valor) ||
        /[+-]\d{2}:\d{2}$/.test(valor)
    ) {
        return valor;
    }

    const data = new Date(valor);

    return Number.isNaN(data.getTime())
        ? valor
        : data.toISOString();
};

const normalizarRegistro = registro => ({
    ...registro,
    datahora_solicitacao:
        normalizarDataHora(registro.datahora_solicitacao),
    id_forma_pagamento:
        Number(registro.id_forma_pagamento) || null,
    quantidade_parcelas:
        Number(registro.quantidade_parcelas) || 1,
    areas: (registro.areas || []).map(area => ({
        ...area,
        area_gps: normalizarNumero(area.area_gps),
        amostras: normalizarNumero(area.amostras),
        tamanho_grid: normalizarNumero(area.tamanho_grid),
        preco_grid: normalizarNumero(area.preco_grid),
        valor_total: calcularValorTotal(area),
        valor_desconto:
            normalizarNumero(area.valor_desconto) || 0,
        zona_manejo: area.zona_manejo === true
    }))
});

export function setModoTela(modo, registro = {}) {
    return {
        type: COLETA_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: COLETA_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    let datahoraSolicitacao = registro.datahora_solicitacao;

    if (datahoraSolicitacao) {
        const data = new Date(datahoraSolicitacao);

        if (!Number.isNaN(data.getTime())) {
            data.setMinutes(
                data.getMinutes() - data.getTimezoneOffset()
            );

            datahoraSolicitacao =
                data.toISOString().substring(0, 16);
        }
    }

    return [
        initialize('coletaForm', {
            ...registro,
            datahora_solicitacao: datahoraSolicitacao,
            id_forma_pagamento:
                Number(registro.id_forma_pagamento) || null,
            quantidade_parcelas:
                Number(registro.quantidade_parcelas) || 1,
            areas: (registro.areas || []).map(area => ({
                ...area,
                valor_total: calcularValorTotal(area),
                valor_final:
                    calcularValorTotal(area) -
                    (
                        normalizarNumero(
                            area.valor_desconto
                        ) || 0
                    )
            }))
        })
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: COLETA_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getOpcoes() {
    return async dispatch => {
        try {
            const resp = await axios.get(`${API}/opcoes`);

            dispatch({
                type: COLETA_OPCOES_CARREGADAS,
                payload: resp
            });

            dispatch({
                type: USUARIO_LISTADO,
                payload: {
                    data: resp.data.consultores || []
                }
            });

        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function getAreasCliente(idCliente) {
    return async dispatch => {
        if (!idCliente) {
            dispatch({
                type: COLETA_AREAS_CARREGADAS,
                payload: {
                    data: []
                }
            });

            return;
        }

        try {
            const resp = await axios.get(`${API}/areas`, {
                params: {
                    id_cliente: idCliente
                }
            });

            dispatch({
                type: COLETA_AREAS_CARREGADAS,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function getHistorico(idColeta) {
    return async dispatch => {
        if (!idColeta) {
            dispatch({
                type: COLETA_HISTORICO_CARREGADO,
                payload: { data: [] }
            });

            return;
        }

        try {
            const resp = await axios.get(`${API}/historico`, {
                params: {
                    id_coleta: idColeta
                }
            });

            dispatch({
                type: COLETA_HISTORICO_CARREGADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado =
                normalizarRegistro(registro);

            const request = registroNormalizado.id
                ? axios.put(API, registroNormalizado)
                : axios.post(API, registroNormalizado);

            await request;

            setSuccess(
                registroNormalizado.id
                    ? 'Coleta atualizada com sucesso.'
                    : 'Coleta criada e enviada para aprovação.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function alterarStatus(registro, statusDestino) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado =
                normalizarRegistro(registro);
            const status = (
                getState().coleta.status || []
            ).find(item => item.codigo === statusDestino);

            if (!status) {
                throw new Error(
                    'Não foi possível identificar o status de destino.'
                );
            }

            if (
                registro.status === 'AGUARDANDO_APROVACAO' &&
                [
                    'REJEITADO',
                    'APROVADO_AGUARDANDO_COLETA'
                ].includes(statusDestino)
            ) {
                await axios.put(API, registroNormalizado);
            }

            await axios.put(`${API}/status`, {
                ...registroNormalizado,
                id_status_destino: status.id
            });

            const mensagens = {
                AGUARDANDO_APROVACAO:
                    'Coleta reaberta para ajustes.',
                REJEITADO: 'Coleta rejeitada.',
                APROVADO_AGUARDANDO_COLETA:
                    'Coleta aprovada e liberada para execução.',
                COLETADO: 'Coleta realizada com sucesso.',
                ENVIADO_LABORATORIO:
                    'Coleta enviada para o laboratório.',
                FINALIZADA: 'Coleta finalizada com sucesso.'
            };

            setSuccess(
                mensagens[statusDestino] ||
                'Etapa da coleta atualizada.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Coleta excluída com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
